import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=049f14c5&scoped=true&"
var script = {}
import style0 from "./Banner.vue?vue&type=style&index=0&id=049f14c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049f14c5",
  null
  
)

export default component.exports